/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legaroo_Landing_BtnInputs */

const en_service_legaroo_landing_btn = /** @type {(inputs: Service_Legaroo_Landing_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn About Legaroo`)
};

const fr_service_legaroo_landing_btn = /** @type {(inputs: Service_Legaroo_Landing_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus sur Legaroo`)
};

/**
* | output |
* | --- |
* | "Learn About Legaroo" |
*
* @param {Service_Legaroo_Landing_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legaroo_landing_btn = /** @type {((inputs?: Service_Legaroo_Landing_BtnInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legaroo_Landing_BtnInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legaroo_landing_btn(inputs)
	return fr_service_legaroo_landing_btn(inputs)
});